import React, { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { usePageTitle } from '../hooks/usePageTitle';
import DocumentUploadStep from '../components/CustomerFlow/Steps/DocumentUploadStep';
import { Card, CardBody, LayoutContainer } from '../components/ui';
import '../styles/infrastructureScreens.css';

const MobileOnboardingPage = () => {
  const { token } = useParams();
  const [searchParams] = useSearchParams();
  
  // Obtener datos del token desde localStorage (ya validados por MobileProtectedRoute)
  const tokenScope = useMemo(() => {
    const storedScope = localStorage.getItem('temp_tokenScope');
    return storedScope ? JSON.parse(storedScope) : {};
  }, []);

  const flowVariant =
    tokenScope.flow_variant === 'approved'
      ? 'approved'
      : (searchParams.get('flowVariant') === 'approved' ? 'approved' : 'initial');

  usePageTitle(flowVariant === 'approved' ? 'Documentación final' : 'Subí tus documentos');
  const enableSelfieVerification =
    flowVariant === 'approved' && process.env.REACT_APP_SELFIE_VERIFICATION_ENABLED === 'true';

  // Manejo de completación de documentos
  const handleDocumentsComplete = (data) => {
    Swal.fire({
      title: '¡Documentos Completados!',
      html: `
        <p>Has completado la carga de documentos exitosamente.</p>
        <small class="text-muted">Puedes cerrar esta solicitudna o continuar cargando documentos opcionales si los hay.</small>
      `,
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Cerrar',
      cancelButtonText: 'Continuar',
    }).then((result) => {
      if (result.isConfirmed) {
        window.close(); // Intenta cerrar la pestaña
      }
      // Si cancela, simplemente continúa en la página
    });
  };

  return (
    <div className="rg-infra-screen rg-mobile-onboarding">
      <LayoutContainer size="lg" className="rg-mobile-onboarding__container">
        <Card className="rg-mobile-onboarding__card rg-elevation-1">
          <CardBody className="rg-mobile-onboarding__card-body">
            <DocumentUploadStep
              standalone={true}
              tokenScope={tokenScope}
              flowVariant={flowVariant}
              enableSelfieVerification={enableSelfieVerification}
              onComplete={handleDocumentsComplete}
            />
          </CardBody>
        </Card>
      </LayoutContainer>
    </div>
  );
};

export default MobileOnboardingPage; 